import type { MinimalTargetState } from '@/generated/model';
import type { TargetStatus } from '@/tmp';

export type TargetRowAction = 'none' | 'share' | 'targetActions';

export type TargetRowActionInput = {
  isSelected: boolean;
  targetState: MinimalTargetState;
  status: TargetStatus | undefined;
  canShare: boolean;
};

export function getTargetRowAction({
  isSelected,
  targetState,
  status,
  canShare,
}: TargetRowActionInput): TargetRowAction {
  if (isSelected && status === 'validstatus') return 'targetActions';
  if (targetState === 'Active' && canShare) return 'share';
  return 'none';
}
